import Firebase from '../lib/Firebase';
import moment from 'moment'

/**
 * Service for storing images on firebase storage
 * @param  {Object} file The image file to be stored
 * @return {Promise} A promise which resolves with image url where it is stored, or an error
 */
export default function(file, collection, docId, title, fileName) {
  return new Promise(resolve => {
    const storageRef = Firebase.storage()
      .ref()
      .child(`${collection}/${fileName}`);
      storageRef.put(file)
      .then(snapshot => {
       return snapshot.ref.getDownloadURL();  
   })
   .then(downloadURL => {
      console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
      const imageObject = {
        url: downloadURL,
        //fileName: file.name,
        uploadedAt: new Date(),
        title : title,
        fileType : 'pdf'
      };
        Firebase.firestore()
        .collection(collection)
        .doc(docId)
        .collection('files')
        .add(imageObject)
        .then(resolve(downloadURL));
      console.log("Database  Entry Done")
      return downloadURL;
   })

   .catch(error => {
      // Use to signal error if something goes wrong.
      console.log(`Failed to upload file and get link - ${error}`);
   });
  });
}



// WEBPACK FOOTER //
// ./src/lib/UploadService.js